<!-- ============================================================== -->
<!-- Main wrapper - style you can find in pages.scss -->
<!-- ============================================================== -->

<div class="main-container">
  <div class="topnav">
    <div style="float: left; overflow: hidden">
      <a routerLink="" style="padding: 5px"
        ><img
        src="/assets/images/logo_totalenergies_v_m.png"
        label="Logo TotalEnergies"
        height="80"
      /></a>
    </div>
    <div class="te-topnav-row-1">
      <div class="app-name">CheckInOut</div>
      <div class="divider"></div>
      <a class="te-te-link" href="https://totalenergies.com/"
        >TotalEnergies.com</a
        >
      </div>
      <div class="te-topnav-row-2" id="te-navbar">
        <a routerLink="">{{ rsc.navHome }}</a>
        <a routerLink="/projects">{{ rsc.navProjects }}</a>
        @if (isRole(allRoleType.admin)) {
          <a routerLink="/companies">{{
            rsc.navCompanies
          }}</a>
        }
        @if (isRole(allRoleType.admin)) {
          <a routerLink="/users">{{
            rsc.navUsers
          }}</a>
        }
        <a routerLink="/authentication/logout">{{ rsc.navLogout }}</a>
        <a href="javascript:void(0);" class="icon" (click)="onBurgerClick()">
          <img src="/assets/images/icon/burger_menu.png" height="30" />
        </a>
      </div>
    </div>

    <div class="page-content">
      <router-outlet></router-outlet>
    </div>

    <footer class="row te-footer">
      <ul>
        <li>
          <a routerLink="authentication/tos/">{{ rsc.termsOfUse }}</a>
        </li>
        <li>v{{ globalAppVersion }}</li>
        <li>&copy; 2025 TotalEnergies</li>
      </ul>
    </footer>
  </div>
